import type { Prototype } from "../prototype-types";

export const emThompsonPrototypes: Prototype[] = [
  {
    id: "savings-visibility",
    name: "Savings Insights",
    path: "/et/savings-visibility",
    description: "Helping retailers understand the savings they get on Faire.",
    owner: "Em",
    createdAt: "2026-03-24",
    lastUpdated: "2026-04-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6905cff8cd32a9f8b89646a13738aba3825b5b32ea855f2da2d6372e360d9346.png",
    creationTool: "cursor",
  },
  {
    id: "retroactive-insider-savings",
    name: "Retroactive Insider Savings",
    path: "/et/retroactive-insider-savings",
    description: "Prototype exploring retroactive Insider savings experiences.",
    owner: "Em",
    createdAt: "2026-01-15",
    lastUpdated: "2026-01-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6aea6dadd6a6017dae706869f007bcdc9d54910f45258fac28672991e1230504.png",
    creationTool: "cursor",
  },
  {
    id: "et-spe-revamp",
    name: "SPE revamp",
    path: "/et/spe-revamp",
    description: "Usability improvements for SPE",
    owner: "Em Thompson",
    createdAt: "2026-08-11",
    lastUpdated: "2026-08-12",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/et-spe-revamp.png",
    creationTool: "claude-code",
  },
  {
    id: "et-lq-retailer-preview",
    name: "LQ retailer preview",
    path: "/et/lq-retailer-preview",
    description:
      "AI-first listing quality flow with a retailer PDP preview and scorecard.",
    owner: "Em Thompson",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-24",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/et-lq-retailer-preview.png",
    creationTool: "cursor",
  },
  {
    id: "et-pdp-attributes-formatting",
    name: "PDP attributes formatting",
    path: "/et/pdp-attributes-formatting",
    description: "",
    owner: "Em Thompson",
    createdAt: "2026-10-07",
    lastUpdated: "2026-10-07",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6c0b0c88dde5b2663d79392e29863a7bebcc457e7993522ce1216bee8a1bcb7f.png",
    creationTool: "cursor",
  },
];
